// Import PGBA common plugin
import PgbaCommonPlugin from '../common/PgbaCommonPlugin';

import Vue from 'vue';
import Vuex from 'vuex';
import VueRouter from 'vue-router';

// Import component parsing utility
import ComponentParser from '../util/ComponentParser';

// Import bootstrap vue components
import BootstrapVue from 'bootstrap-vue';

// Import custom landing content components
import LandingContent from './components/LandingContent.vue';

// Import landing content resources
import {getStore, getRouter} from './landing-content-resources';

// Register framework libraries
Vue.use(Vuex);
Vue.use(VueRouter);
Vue.use(BootstrapVue);
Vue.use(PgbaCommonPlugin);

const store = getStore();
const router = getRouter();

ComponentParser.parse('pgba-landing-content', LandingContent, { store, router });
